// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Rose of Sharon Primary School",
    image: "/school-logo.png",
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "#",
    },
    {
      icon: <WhatsAppIcon />,
      link: "#",
    },
    {
      icon: <EmailIcon />,
      link: "mailto:info@rosps.co.zw",
    },
    {
      icon: <PhoneIcon />,
      link: "tel:+263772490478",
    },
  ],
  menus: [
    {
      name: "Quick Links",
      items: [
        { name: "Home", route: "/" },
        { name: "About Us", route: "/about" },
        { name: "Academics", route: "/academics" },
        { name: "Admissions", route: "/admissions" },
      ],
    },
    {
      name: "School Life",
      items: [
        { name: "Why Choose Us", route: "/why-choose-us" },
        { name: "School Life", route: "/school-life" },
        { name: "Gallery", route: "/gallery" },
        { name: "Contact Us", route: "/contact" },
      ],
    },
    {
      name: "Contact Info",
      items: [
        { name: "6521 Nicoz Diamond Zimre Park" },
        { name: "+263 772 490 478" },
        { name: "+263 772 703 215" },
        { name: "Mon - Fri: 7:30 AM - 4:30 PM" },
      ],
    },
    {
      name: "Our Values",
      items: [
        { name: "Academic Excellence" },
        { name: "Christian Foundation" },
        { name: "Character Development" },
        { name: "Safe Environment" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date}{" "}
      <MKTypography
        component="a"
        href="/"
        variant="button"
        fontWeight="regular"
      >
        Rose of Sharon Primary School
      </MKTypography>
      . Nurturing Minds, Building Character, Inspiring Faith.
    </MKTypography>
  ),
};
